import { createContext, useContext, type ReactNode } from 'react';

interface TabContextValue {
  tabName: string | null;
}

const TabContext = createContext<TabContextValue>({ tabName: null });

export interface TabProviderProps {
  tabName: string;
  children: ReactNode;
}

export function TabProvider({ tabName, children }: TabProviderProps) {
  return <TabContext.Provider value={{ tabName }}>{children}</TabContext.Provider>;
}

export function useTabContext(): TabContextValue {
  // typically in useContext hooks we validate the context is not null,
  // but here we don't want to validate the context is not null because we want to
  // allow the context to be null when the component is not wrapped in a TabProvider
  return useContext(TabContext);
}
